export default {
  data() {
    return {
      exit_destroy : true
    }
  },
  beforeDestroy(){

      this.exit_destroy = false
  },

  methods:{
    $_softFormat(obj){

      if(obj.docker_container_name !== undefined && obj.docker_container_name !== '非容器' && obj.docker_container_name !== null && obj.docker_container_name !== ''){
        return obj.docker_container_name
      }else if(obj.soft_type_name !== undefined && obj.soft_type_name !== null && obj.soft_type_name.toUpperCase().indexOf("JBOSS") > -1){

        var temp_str = obj.soft_type_name.substring(obj.soft_type_name.indexOf("（") + 1, obj.soft_type_name.indexOf("）"))
        // if(obj.service_port !== undefined && obj.service_port !== null && obj.portoffset !== undefined && obj.portoffset !== null){
        //
        // }
        let server_port = obj.service_port
        let portoffset = obj.portoffset
        let port = 0
        if(portoffset){
          port = parseInt(portoffset)
        }
        if(server_port){
          port += parseInt(server_port)
        }

        return temp_str + "_" + port
      }else{
        if(obj.soft_type_name == undefined || obj.soft_type_name == null){
          return ''
        }else {
          let server_port = obj.service_port
          return obj.soft_type_name+"_"+server_port
        }
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/common_page/mixin/common.js